import React from 'react';
import { DESIGN_TOKENS } from '../../constants/designTokens';

const surface = DESIGN_TOKENS.surface;

const VARIANT_CLASS = {
    card: surface.cardClass,
    soft: surface.softCardClass,
};

const AppCard = React.forwardRef(function AppCard({
    as: Tag = 'div',
    variant = 'card',
    className = '',
    children,
    ...rest
}, ref) {
    const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.card;

    return (
        <Tag ref={ref} className={`${variantClass} ${className}`.trim()} {...rest}>
            {children}
        </Tag>
    );
});

export default AppCard;
